import React from 'react';
import cn from 'classnames';
import Bullets from 'slickpay/common/Bullets.component';

import Button from 'components/form/Button.component';
import Icon from 'components/generic/Icon.component';
import S from 'constants/string.const';
import useTip from 'hooks/useTip.hook';
import { useTranslation } from 'providers/GILT.provider';
import { useTheme } from 'providers/Theme.provider';
import fromAnyToTrimmed from 'utils/converters/any/fromAnyToTrimmed.util';

import CN from './CardWaitlist.module.scss';

const CardWaitlist = ({ tag }) => {
  const { isDarkMode } = useTheme();
  const { t } = useTranslation();
  const { val: isFoldOpen, tip: toggleFold } = useTip(true);

  const DATA_BULLETS = [
    <div className={CN.bullet}>
      <span className={CN.emoji}>{S.passdot} </span>
      {t('composite.waitlistCard.functBullet1')}
    </div>,
    <div className={CN.bullet}>
      <span className={CN.emoji}>{S.passdot} </span>
      {t('composite.waitlistCard.functBullet2')}
    </div>,
    <div className={CN.bullet}>
      <span className={CN.emoji}>{S.passdot} </span>
      {t('composite.waitlistCard.functBullet3')}
    </div>,
  ];

  const DATA_BULLETS_RULES = [
    <div className={CN.bullet}>
      <span className={CN.emoji}>{S.markVGreen} </span>
      {t('composite.waitlistCard.rememberBullet1')}
    </div>,
    <div className={CN.bullet}>
      <span className={CN.emoji}>{S.markVGreen} </span>
      {t('composite.waitlistCard.rememberBullet2')}
    </div>,
    <div className={CN.bullet}>
      <span className={CN.emoji}>{S.crossMark} </span>
      {t('composite.waitlistCard.rememberBullet3')}
    </div>,
    <div className={CN.bullet}>
      <span className={CN.emoji}>{S.crossMark} </span>
      {t('composite.waitlistCard.rememberBullet4')}
    </div>,
    <div className={CN.bullet}>
      <span className={CN.emoji}>{S.crossMark} </span>
      {t('composite.waitlistCard.rememberBullet5')}
    </div>,
  ];

  return (
    <div
      data-bem="CardWaitlist"
      data-tag={fromAnyToTrimmed(tag)}
      className={cn({
        [CN.component]: true,
        [CN.dark]: isDarkMode,
      })}
    >
      <div className={CN.title}>{t('composite.waitlistCard.title')}</div>
      <Bullets data={DATA_BULLETS} empty tag="CardWaitlist" />

      <div data-bem="CardWaitlist__fold" className={CN.fold}>
        <div className={CN.toggleFoldContainer}>
          <span className={CN.subTitle}>{t('composite.waitlistCard.subTitle')}</span>
          <div className={CN.arrowContainer}>
            <Button variant="icon" width="small" onClick={toggleFold}>
              <Icon
                tag="CardWaitlist__arrow"
                variant="arrowFoldout"
                selected={!isFoldOpen}
                unselected={isFoldOpen}
                width="lg"
              />
            </Button>
          </div>
        </div>

        {isFoldOpen && (
          <div data-bem="CardWaitlist__fold-content" className={CN.content}>
            <Bullets data={DATA_BULLETS_RULES} empty tag="CardWaitlist" />
          </div>
        )}
        <div className={CN.disclaimer}>{t('composite.waitlistCard.disclaimer')}</div>
      </div>
    </div>
  );
};

export default CardWaitlist;
